import React from "react";

const SelectAirport = ({
  airports,
  activeAirport,
  onChangeActiveAirport,
  disabled = false,
  reqFuel,
  blockFuel = 0,
  tankeringValue = 0,
  contingencyAirportICAO = null,
}) => {
  const getFuelValue = (fuelData) => {
    if (fuelData === null || fuelData === undefined) return 0;
    const value = Array.isArray(fuelData) ? fuelData[0] : fuelData;
    return Number(value) || 0;
  };

  const isReachable = (airport) => {
    const extraFuel = Number(tankeringValue) || 0;
    const availableFuel = (reqFuel || 0) * 1000 + extraFuel;

    if (airport?.sAirportFunction?.[0] === "ArrivalAirport") {
      return availableFuel > (blockFuel || 0);
    }

    return (
      availableFuel >
      (blockFuel || 0) -
        getFuelValue(airports?.[2]?.nAlternateFuel_KG) +
        getFuelValue(airport?.nAlternateFuel_KG)
    );
  };

  const getAirportColor = (airport) => {
    const airportICAO = airport?.sICAO?.[0] ?? airport?.sADICAO?.[0];

    // If this is an ApprovedAlternate, always return grey
    if (airport?.sADFunction?.[0] === "ApprovedAlternate") {
      return "#bbb";
    }

    // Contingency airport (ERA only, not also alternate)
    if (contingencyAirportICAO && airportICAO === contingencyAirportICAO) {
      return "blue";
    }

    const isAlternate =
      airport?.sAirportFunction?.[0] !== "DepartureAirport" &&
      airport?.sAirportFunction?.[0] !== "ArrivalAirport";

    if (isAlternate && getFuelValue(airport?.nAlternateFuel_KG) === 0) {
      return "grey";
    }

    return isReachable(airport) ? "#84C083" : "grey";
  };

  const regularAirports = airports.filter(
    (airport) => airport?.sADFunction?.[0] !== "ApprovedAlternate"
  );
  const approvedAlternates = airports.filter(
    (airport) => airport?.sADFunction?.[0] === "ApprovedAlternate"
  );

  const renderAirportItem = (airport, i) => (
        <li
          key={i}
          style={{
            fontWeight: 650,
            fontSize: "18px",
            color: getAirportColor(airport),
            cursor: !disabled ? "pointer" : "default",
            textDecoration:
              (activeAirport?.sICAO ?? activeAirport?.sADICAO) ===
                (airport?.sICAO ?? airport?.sADICAO) && !disabled
                ? "underline"
                : "none",
            flexShrink: 0,
        display: "flex",
        alignItems: "center",
        gap: "4px",
          }}
          onClick={() => !disabled && onChangeActiveAirport(airport)}
        >
          {airport?.sICAO ?? airport?.sADICAO}
        </li>
  );

  return (
    <div>
      <ul
        style={{
          listStyle: "none",
          display: "flex",
          flexWrap: "wrap",
          width: "100%",
          justifyContent: "space-between",
          padding: "0 16px 0 32px",
          gap: "16px",
        }}
      >
        {regularAirports.map((airport, i) => renderAirportItem(airport, i))}
      </ul>
      {approvedAlternates.length > 0 && (
        <ul
          style={{
            listStyle: "none",
            display: "flex",
            flexWrap: "wrap",
            width: "100%",
            justifyContent: "space-between",
            padding: "0 16px 0 32px",
            gap: "16px",
            marginTop: "8px",
          }}
        >
          {approvedAlternates.map((airport, i) =>
            renderAirportItem(airport, `approved-${i}`)
          )}
    </ul>
      )}
    </div>
  );
};

export default SelectAirport;
